package com.milta.core.connectivity

import kotlinx.browser.window
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import org.w3c.dom.events.Event

/** Kotlin/JS implementation of [ConnectivityObserver] — `navigator.onLine` plus the browser's
 * `online`/`offline` window events. */
class JsConnectivityObserver : ConnectivityObserver {

    private val _isOnline = MutableStateFlow(window.navigator.onLine)
    override val isOnline: StateFlow<Boolean> = _isOnline

    init {
        window.addEventListener("online", { _: Event -> _isOnline.value = true })
        window.addEventListener("offline", { _: Event -> _isOnline.value = false })
    }
}
